// Curated, biblically conservative scripture set (NIV) used throughout Rising Force Academy.
export const VERSES = [
  { text: "For the LORD gives wisdom; from his mouth come knowledge and understanding.", ref: "Proverbs 2:6 (NIV)" },
  { text: "Trust in the LORD with all your heart and lean not on your own understanding.", ref: "Proverbs 3:5 (NIV)" },
  { text: "Whatever you do, work at it with all your heart, as working for the Lord, not for human masters.", ref: "Colossians 3:23 (NIV)" },
  { text: "Start children off on the way they should go, and even when they are old they will not turn from it.", ref: "Proverbs 22:6 (NIV)" },
  { text: "I can do all this through him who gives me strength.", ref: "Philippians 4:13 (NIV)" },
  { text: "Your word is a lamp for my feet, a light on my path.", ref: "Psalm 119:105 (NIV)" },
  { text: "The fear of the LORD is the beginning of knowledge, but fools despise wisdom and instruction.", ref: "Proverbs 1:7 (NIV)" },
  { text: "Be strong and courageous. Do not be afraid; do not be discouraged, for the LORD your God will be with you wherever you go.", ref: "Joshua 1:9 (NIV)" },
  { text: "And we know that in all things God works for the good of those who love him, who have been called according to his purpose.", ref: "Romans 8:28 (NIV)" },
  { text: "Do everything in love.", ref: "1 Corinthians 16:14 (NIV)" },
  { text: "This is the day the LORD has made; let us rejoice and be glad in it.", ref: "Psalm 118:24 (NIV)" },
  { text: "but those who hope in the LORD will renew their strength.", ref: "Isaiah 40:31 (NIV)" },
];

// Deterministic "verse of the day" so it is stable within a calendar day.
export function verseOfTheDay() {
  const now = new Date();
  const dayOfYear = Math.floor((now - new Date(now.getFullYear(), 0, 0)) / 86400000);
  return VERSES[dayOfYear % VERSES.length];
}
